import { render, staticRenderFns } from "./ToolbarMovimenti.vue?vue&type=template&id=22c4f286"
import script from "./ToolbarMovimenti.vue?vue&type=script&lang=js"
export * from "./ToolbarMovimenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports